export const App = 'app'

export const GitHub = 'github'

export const Web = 'web'

export const Data = 'data'

export const Memfs = 'memfs'

export const Html = 'html'

export const ExtensionHost = 'extension-host'

export const Fetch = 'fetch'
